import clsx from 'clsx';
import { useToast } from '../../../hooks';
import { ComponentSize } from '../../../types';
import { Icon, Icons } from '../Icons';
import { ALERT_TYPE_TO_CLASSNAME, ALERT_TYPE_TO_ICON } from './Alert.constants';
import { AlertProps, AlertType } from './Alert.types';

const Alert = ({ id, message, canDismiss, title, type }: AlertProps) => {
  const { hideToast } = useToast();

  return (
    <div className={clsx('alert max-w-md border-none shadow-dialog', type && ALERT_TYPE_TO_CLASSNAME[type])}>
      <Icons icon={ALERT_TYPE_TO_ICON[type ?? AlertType.INFO]} color="text-inherit" size={ComponentSize.LARGE} />
      <div className="flex flex-col gap-1">
        {!!title && <span className="whitespace-normal text-base font-semibold">{title}</span>}
        <span className={clsx('whitespace-normal', title && 'text-base-content/60')}>{message}</span>
      </div>
      {canDismiss && <Icons color="text-inherit" icon={Icon.CLOSE} onClick={() => hideToast(id)} />}
    </div>
  );
};

export default Alert;
